import TableRow from "../../../table/TableRow";
import _ from "underscore";

function TabularDataTableRow() {}

TabularDataTableRow.prototype = _.create(TableRow.prototype);

TabularDataTableRow.prototype.init = function()
{
    TableRow.call( this );
    return this;
};

TabularDataTableRow.prototype.canBeDeletedPermanently = function()
{
    return true;
};


TabularDataTableRow.prototype.validate = function()
{
    return true;
};

TabularDataTableRow.prototype.isMarkedToRemove = function()
{
    return this.markedToRemove;
};

TabularDataTableRow.prototype.markToRemove = function()
{
    this.markedToRemove = true;
    this.updateUI();
};

TabularDataTableRow.prototype.unMarkToRemove = function()
{
    this.markedToRemove = false;
    this.updateUI();
};

TabularDataTableRow.prototype.getRowClasses = function()
{
    var classes = TableRow.prototype.getRowClasses.call( this );
    if( this.markedToRemove )
        classes.push( "markedToRemove" );
    return classes;
};

TabularDataTableRow.prototype.updateRowClasses = function()
{
    this.getRowEl().className = this.getRowClasses().join(" ");
};


TabularDataTableRow.prototype.updateUI = function()
{
    this.updateRowClasses();
    for( var i = 0; i < this.cells.length; i++ )
        this.updateCellUI( i );
};

TabularDataTableRow.prototype.hasErrors = function()
{
    return false;
};

export default TabularDataTableRow;



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataTableRow.js